import PropTypes from "prop-types";

export const GridType = {
	children: PropTypes.node.isRequired,
	grid: PropTypes.string.isRequired
};
